//
// menu.js
//
// author: marcio.garcia@newsoftware.com.br
//

export const menu = [
    { id: "Products" },
    { id: "Services" },
    { id: "Cases" },
    { id: "About" }
];

